import axios from 'axios';
import { useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { useSnackbar } from 'hooks/UseSnackbar';
import { useTranslation } from 'react-i18next';
import { useQueryLSBDTransactions } from './useQueryLSBDTransactions';
import { useQueryLSBDDashboard } from './useQueryLSBDDashboard';

export const useMutationCancelTransaction = setOpen => {
    const toast = useSnackbar();
    const [t] = useTranslation();

    const queryTransactions = useQueryLSBDTransactions({ enabled: false });
    const queryLSBDDashboard = useQueryLSBDDashboard({});

    const mutation = useMutation({
        mutationFn: async obj =>
            await axios.post(
                process.env.REACT_APP_SERVER +
                    `api/Quota/Transactions/${obj.get('id')}/Cancel`,
                obj,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            ),
        onSuccess: res => {
            toast.success(t('QUOTAS.transactionCanceledSuccess'));
        },
        onError: () => {
            toast.error(t('QUOTAS.transactionCanceledError'));
        },
        onSettled: () => {
            setOpen(false);
            queryTransactions.refetch();
            queryLSBDDashboard.refetch();
        }
    });

    return mutation;
};
